import { images } from "./constants";

export const abouts = [
  {
    title: "Web Development",
    description: "I am a good web developer.",
    imgUrl: images.about01,
  },
  {
    title: "Frontend Development",
    description: "I am a good web developer.",
    imgUrl: images.about02,
  },
  {
    title: "backend Development",
    description: "I am a good web developer.",
    imgUrl: images.about03,
  },
  {
    title: "MERN Stack",
    description: "I am a good web developer.",
    imgUrl: images.about04,
  },
];

export const myWorks = [
  {
    title: "Modern UI/UX Website",
    description: "A Modern UI/UX Portfolio Website",
    imgUrl: images.about01,
    tags: "UI/UX",
    tag: "All",
    projectLink: "#",
    codeLink: "#",
  },
  {
    title: "Gericht Restaurant Project",
    description: "I am a good web developer.",
    imgUrl: images.about02,
    tags: "Mobile App",
    tag: "All",
    projectLink: "#",
    codeLink: "#",
  },
  {
    title: "Web Aplication",
    description: "A Responsive Website",
    imgUrl: images.about03,
    tags: "Web App",
    tag: "All",
    projectLink: "#",
    codeLink: "#",
  },
  {
    title: "React E-Commerce",
    description: "E-Commerce Aplication with React JS",
    imgUrl: images.about04,
    tags: "React JS",
    tag: "All",
    projectLink: "#",
    codeLink: "#",
  },
  {
    title: "Modern UI/UX Website",
    description: "A Modern UI/UX Portfolio Website",
    imgUrl: images.about01,
    tags: "UI/UX",
    tag: "All",
    projectLink: "#",
    codeLink: "#",
  },
  {
    title: "Gericht Restaurant Project",
    description: "I am a good web developer.",
    imgUrl: images.about02,
    tags: "Mobile App",
    tag: "All",
    projectLink: "#",
    codeLink: "#",
  },
  {
    title: "Web Aplication",
    description: "A Responsive Website",
    imgUrl: images.about03,
    tags: "Web App",
    tag: "All",
    projectLink: "#",
    codeLink: "#",
  },
  {
    title: "React E-Commerce",
    description: "E-Commerce Aplication with React JS",
    imgUrl: images.about04,
    tags: "React JS",
    tag: "All",
    projectLink: "#",
    codeLink: "#",
  },
];

export const skills = [
  {
    name: "Git",
    icon: images.git,
    bgColor: "#eee",
  },
  {
    name: "React",
    icon: images.react,
    bgColor: "#eee",
  },
  {
    name: "Node.JS",
    icon: images.node,
    bgColor: "#eee",
  },
  {
    name: "Figma",
    icon: images.figma,
    bgColor: "#eee",
  },
  {
    name: "Flutter",
    icon: images.flutter,
    bgColor: "#eee",
  },
];

export const experiences = [
  {
    year: "2020",
    works: [
      {
        name: "Frontend Developer",
        company: "Google",
        desc: "I worked as a frontend developer at Goole",
        key: 1,
      },
    ],
  },
  {
    year: "2022",
    works: [
      {
        name: "Backend Developer",
        company: "Meta",
        desc: "I worked with Node.js and VR",
        key: 2,
      },
    ],
  },
  {
    year: "2023",
    works: [
      {
        name: "Blockchain",
        company: "Facebook",
        desc: "I develop in Solidity",
        key: 3,
      },
    ],
  },
];

export const testimonials = [
  {
    name: "Ahmed",
    company: "Google",
    imgurl: images.css,
    feedback:
      "Ahmed is an awsome developer! I am a frontend developer with a passion for building beautiful and functional web aplications.",
  },
  {
    name: "Ibrahim",
    company: "Netflix",
    imgurl: images.html,
    feedback:
      "Ibrahim is an awsome developer! I am a backend developer with a passion for building beautiful and functional web aplications.",
  },
  {
    name: "Shierf",
    company: "Amazon",
    imgurl: images.flutter,
    feedback: "I am a great analyst.",
  },
  {
    name: "Omran",
    company: "Facebook",
    imgurl: images.javascript,
    feedback: "I am a great Programmer.",
  },
  {
    name: "Mohammed",
    company: "Meta",
    imgurl: images.node,
    feedback: "I am a good Node.js Developer.",
  },
];

export const brands = [
  {
    imgUrl: images.nb,
    name: "New Balance",
  },
  {
    imgUrl: images.skype,
    name: "Skype",
  },
  {
    imgUrl: images.bolt,
    name: "Bolt",
  },
  {
    imgUrl: images.spotify,
    name: "Spotify",
  },
];
